module.exports = __webpack_public_path__ + "static/media/parapluie.ab860c4a.svg";